import { gql } from '@apollo/client';

export const getPlansForMsWizard = gql`
  query($zipCode: String!, $gender: String!) {
    getPlansForMsWizard(zipCode: $zipCode, gender: $gender) {
      planN {
        drxId
        planBrandName
        planName
        carrierName
        drxCarrierName
        annualPremium
        summaryOfBenefitsLink
      }
      planG {
        drxId
        planBrandName
        planName
        carrierName
        drxCarrierName
        annualPremium
        summaryOfBenefitsLink
      }
    }
  }
`;
